import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CFormInput, CListGroup, CListGroupItem, CSpinner } from '@coreui/react'
import { get } from '../../utils/apiClient'
import Avatar from '../shared/Avatar'

const TagSelector = ({ onSelectPerson }) => {
  const { t } = useTranslation()
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentUserId, setCurrentUserId] = useState(parseInt(localStorage.getItem('userId'), 10))

  useEffect(() => {
    if (query.length < 2) {
      setResults([])
      return
    }

    const searchMembers = async () => {
      setLoading(true)
      try {
        const data = await get(`/search/members?query=${encodeURIComponent(query)}`)
        setResults(data || [])
      } catch (error) {
        console.error('Erreur lors de la recherche de membres:', error)
        setResults([])
      } finally {
        setLoading(false)
      }
    }

    const debounce = setTimeout(() => {
      searchMembers()
    }, 300)

    return () => clearTimeout(debounce)
  }, [query])

  return (
    <div className="tag-selector">
      <CFormInput
        type="text"
        placeholder={t('posts:tagging.searchPerson')}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="mb-2"
        autoFocus
      />

      <div className="tag-results">
        {loading ? (
          <div className="text-center py-3">
            <CSpinner size="sm" />
          </div>
        ) : results.length > 0 ? (
          <CListGroup>
            {results.map((member) => (
              <CListGroupItem
                key={member.id}
                className="px-3 py-2 d-flex align-items-center gap-2 cursor-pointer hover-bg-light"
                onClick={(e) => {
                  e.stopPropagation()
                  onSelectPerson(member)
                }}
                style={{ zIndex: 1070 }}
              >
                <Avatar user={member} size={32} />
                <div>
                  <div className="fw-semibold">
                    {member.firstName} {member.lastName}
                  </div>
                  {member.position && <small className="text-muted">{member.position}</small>}
                </div>
              </CListGroupItem>
            ))}
          </CListGroup>
        ) : query.length >= 2 ? (
          <div className="text-center text-muted py-3">{t('posts:tagging.noResults')}</div>
        ) : (
          <div className="text-center text-muted py-3">{t('posts:tagging.startTyping')}</div>
        )}
      </div>

      <style>{`
        .tag-results {
          max-height: 200px;
          overflow-y: auto;
          scrollbar-width: thin;
        }
        
        .cursor-pointer {
          cursor: pointer;
        }
        
        .hover-bg-light:hover {
          background-color: var(--cui-gray-100);
        }
        
        .tag-selector {
          position: relative;
          z-index: 1070;
        }
      `}</style>
    </div>
  )
}

export default TagSelector
